module.exports = __webpack_public_path__ + "img/fashion_84.b06a52e1.jpg";